
export const storeFilters = (page, dataStateChange?) => {
    localStorage.setItem(page, JSON.stringify(dataStateChange));
}